import type { FunctionComponent } from 'react';
import { Suspense } from 'react';

import { useLazyComponent } from '@trello/use-lazy-component';

export const LazyPowerUpApiKeyPage: FunctionComponent<{
  idPlugin: string;
}> = ({ idPlugin }) => {
  const PowerUpApiKeyPage = useLazyComponent(
    () =>
      import(/* webpackChunkName: "app-management" */ './PowerUpApiKeyPage'),
    {
      namedImport: 'PowerUpApiKeyPage',
    },
  );
  return (
    <Suspense fallback={null}>
      <PowerUpApiKeyPage idPlugin={idPlugin} />
    </Suspense>
  );
};
